import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Chip, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { PieChart } from './PieChart';
import ViewReportButton from '../../components/ViewReportButton';
import {
  AssessmentEnum,
  ModeOfConductionEnum,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';

const styles: IStyles = {
  root: {
    width: { xs: '100%', md: pxTovW(700), lg: '100%' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: { xs: '0px', md: pxToRem(10) },
    backgroundColor: '#FFFFFF',
    border: { md: '1px solid #E0DFDE' },
    gap: pxToRem(10),
    // gap: pxToRem(10),
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    padding: { xs: pxToRem(20), md: pxTovW(20) },
  },
};
interface IChartComponentProps {
  obtainedMarks: number;
  maxMarks: number;
  title: string;
  color: string;
}
interface IProps {
  assessmentType?: AssessmentEnum;
  chartData: IChartComponentProps[];
  homeworkId?: bigint;
  reportButtonHandler?: () => void;
  jeeMarking?: boolean;
  subjectName?: string;
  taskType?: TaskEnum;
  reportSubject?: string;
  reportClassName?: string;
  reportSection?: string;
  modeOfConduction?: ModeOfConductionEnum;
  attemptNumber?: number;
  isBestAttempt?: boolean;
}
export const ChartBox = (props: IProps) => {
  return props.chartData.length > 0 ? ( //  if bloomdata is not empty
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          //   alignItems: 'center',
          paddingX: pxTovW(15),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // alignItems: 'center ',
            justifyContent: 'center',
            gap: pxToRem(10),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(5), md: pxTovW(10) },
            }}
          >
            <Typography variant="h3" fontWeight="bold">
              Key Highlights of Report
            </Typography>
            {props.subjectName && (
              <Chip
                label={props.subjectName}
                color="primary"
                size="small"
                sx={{ fontSize: pxToRem(12), fontWeight: 'bold' }}
              />
            )}
          </Box>
          {!props.jeeMarking && (
            <Typography variant="bodyText">Bloom Level Scores</Typography>
          )}
        </Box>
        {!!props.homeworkId && (
          <ViewReportButton
            homeworkId={props.homeworkId}
            reportButtonHandler={props.reportButtonHandler}
            subject={props.reportSubject}
            className={props.reportClassName}
            section={props.reportSection}
            modeOfConduction={props.modeOfConduction}
            attemptNumber={props.attemptNumber}
            isBestAttempt={props.isBestAttempt}
          />
        )}
        {/* {props.homeworkId &&
          props.taskType ===
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #7CCF96',
                color: '#18984B',
                borderRadius: pxToRem(6),
                width: pxToRem(120),
                height: pxToRem(32),
                fontSize: { xs: pxToRem(11), md: pxTovW(12) },
                fontWeight: 700,
                lineHeight: 1,
                boxSizing: 'border-box',
                flexShrink: 0,
              }}
            >
              Full Report
            </Box>
          )} */}
      </Box>
      {!props.jeeMarking && (
        <Grid
          container
          spacing={2}
          sx={{ width: '100%', justifyContent: 'center' }}
          xs={12}
          sm={12}
          md={12}
          lg={12}
        >
          {props.chartData.map((elem, index) =>
            elem.obtainedMarks && elem.obtainedMarks > 0 ? (
              <Grid item key={index} xs={12} sm={12} md={6} lg={6}>
                {
                  <Box
                    sx={{
                      display: 'flex',
                      boxSizing: 'border-box',
                      alignItems: 'center',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      border: '1px solid #00000029',
                      borderRadius: pxTovW(10),
                      width: '100%',
                      height: 'max-content',
                      paddingY: pxTovW(15),
                      paddingX: pxTovW(30),
                    }}
                  >
                    <PieChart
                      variant="medium"
                      obtainedMarks={elem.obtainedMarks}
                      maxMarks={elem.maxMarks}
                      title={elem.title}
                      color={elem.color}
                    />
                  </Box>
                }
              </Grid>
            ) : null
          )}
        </Grid>
      )}
    </Box>
  ) : (
    // if assessment type is not diagnostic and bloomdata is empty
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          //   alignItems: 'center',
          paddingX: pxTovW(15),
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h3" fontWeight="bold">
            Reports
          </Typography>
        </Box>

        {!!props.homeworkId && (
          <ViewReportButton
            homeworkId={props.homeworkId}
            reportButtonHandler={props.reportButtonHandler}
            subject={props.reportSubject}
            className={props.reportClassName}
            section={props.reportSection}
            modeOfConduction={props.modeOfConduction}
            attemptNumber={props.attemptNumber}
            isBestAttempt={props.isBestAttempt}
          />
        )}
      </Box>
    </Box>
  );
};
